import React from 'react';
import {
    IconAlertTriangleFilled,
    IconCaretDownFilled,
    IconCaretUpFilled,
} from '@tabler/icons-react';
import { Text } from '@mantine/core';

type Props = {
    title: string;
    count: number;
    difference?: number;
    alert?: boolean;
    icon: React.ReactNode;
    backgroundColor: string;
};

function RequestCardItem({
    title,
    count,
    difference,
    icon,
    alert,
    backgroundColor,
}: Props) {
    return (
        <div className="flex flex-1 flex-col px-10 border-solid border-y-0 border-l-1 border-r-0 border-[#F0F1F3] first-of-type:border-none">
            <div
                className="rounded-full p-2 w-min flex items-center justify-center mb-3 relative"
                style={{
                    backgroundColor,
                }}
            >
                {alert && (
                    <div className="absolute top-0 -right-2 -mt-1 -mr-1 rounded-full bg-red-500/20 text-red-500 w-6 h-6 flex items-center justify-center p-1">
                        <IconAlertTriangleFilled size={16} />
                    </div>
                )}
                {icon}
            </div>
            <div className="flex flex-col flex-1 w-max">
                <Text className="text-[#444444] font-semibold text-[14px]">
                    {title}
                </Text>
                <div className="flex flex-1 gap-2 items-center">
                    <Text className="text-[#5D6679]  font-black text-[24px]">
                        {count}
                    </Text>
                    {!!difference && (
                        <div className="flex items-center gap-1">
                            <Text>
                                {difference < 0
                                    ? `${difference} less`
                                    : `${difference} more`}
                            </Text>
                            {difference > 0 ? (
                                <IconCaretUpFilled
                                    className="text-green-500"
                                    size={20}
                                />
                            ) : (
                                <IconCaretDownFilled
                                    className="text-red-500"
                                    size={20}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RequestCardItem;
